import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SecondaryHeaderInfo = ({
  SecondaryHeaderTitle,
  SecondaryHeaderText,
  SecondaryText
}) => /*#__PURE__*/_jsx("div", {
  className: "info-wrap",
  children: SecondaryText ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h3", {
      children: SecondaryHeaderTitle
    }), /*#__PURE__*/_jsx("span", {
      children: SecondaryHeaderText
    })]
  }) : /*#__PURE__*/_jsx("h3", {
    children: SecondaryHeaderTitle
  })
});

export default SecondaryHeaderInfo;